import React from "react";
import "../App.css";
import logo from "../assets/logo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Footer Left Section with Logo */}
        <div className="footer-left">
          <img src={logo} alt="Core Flow Fit Logo" className="footer-logo" />
          <p className="footer-description">
            We are a leading fitness system in the United States, with 10 years
            of experience in the fitness industry and trusted by over 100,000
            customers.
          </p>
        </div>

        {/* Footer Links Section */}
        <div className="footer-links">
          <h3>Support</h3>
          <ul>
            <li><a href="/terms-of-service">Terms of Service</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/refund-policy">Refund Policy</a></li>
          </ul>
        </div>

        {/* Footer Contact Section */}
        <div className="footer-contact">
          <h3>Contact</h3>

          <p>
            <i className="fas fa-phone-alt"></i>{" "}
            <a
              href="tel:07548889409"
              style={{ color: "white", textDecoration: "none" }}
            >
              07548 889409
            </a>
          </p>

          <p>
            <i className="fas fa-envelope"></i>{" "}
            <a href="mailto:infocoreflowfit@gmail.com">
              infocoreflowfit@gmail.com
            </a>
          </p>

          <p>
            <i className="fas fa-map-marker-alt"></i>{" "}
            UK
          </p>
        </div>

        {/* Footer Social Media Section */}
        <div className="footer-social">
          <h3>Follow Us</h3>
          <div className="social-icons">

            {/* Facebook */}
            <a href="https://www.facebook.com/share/1ATp3vpbLJ/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook-f"></i>
            </a>

            {/* Instagram */}
            <a href="https://www.instagram.com/atillar8" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>

            {/* YouTube */}
            <a href="https://www.youtube.com/@atillarado5418" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-youtube"></i>
            </a>

            {/* TikTok */}
            <a href="https://www.tiktok.com/@atillarado" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-tiktok"></i>
            </a>

            {/* Threads */}
            <a href="https://www.threads.com/@atillar8" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-threads"></i>
            </a>

          </div>
        </div>
      </div>

      {/* Divider Line */}
      <div className="footer-line"></div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>
          © Copyright 2025. All rights reserved | Powered by{" "}
          <a
            href="https://teqnoor.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Teqnoor
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;